import { Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import { Item } from 'typings'
import {
  CONNECTOR,
  Rule,
  RuleActions,
  RuleContent,
  RuleDefaultActions,
  RuleDescription,
  RuleIcon,
  TagItem,
  TagsList,
} from 'ui'
import { IconComponent } from '../IconComponent'
import { messages } from '../messages'
import { SCOPE_OPTIONS } from '../typing'

type Props = {
  config: Item[]
  onEdit: () => void
  onRemove: (field: string) => void
}

export function CollectionsRule(props: Props) {
  const { config, onEdit, onRemove } = props
  return (
    Boolean(config.length) && (
      <Rule onClick={onEdit} connector={CONNECTOR.OR}>
        <RuleIcon>
          <IconComponent icon={SCOPE_OPTIONS.COLLECTIONS} />
        </RuleIcon>

        <RuleDescription>
          <FormattedMessage
            {...messages[SCOPE_OPTIONS.COLLECTIONS]}
            values={{
              count: config.length,
              b: (content) => <Text variant="body">{content}</Text>,
            }}
          />
        </RuleDescription>

        <RuleContent>
          <TagsList>
            {config.map((item, index) => (
              <TagItem key={index} item={item} />
            ))}
          </TagsList>
        </RuleContent>

        <RuleActions>
          <RuleDefaultActions
            onEdit={onEdit}
            onRemove={() => onRemove(SCOPE_OPTIONS.COLLECTIONS)}
          />
        </RuleActions>
      </Rule>
    )
  )
}
